import DataBinder from "../DataBinder.js"
import SwapPage from "../SwapPage.js"
export default class LoginController {

  constructor(app) {
    this.app = app;
  }
  show(path, model) {


    //get page
    let pageId = path.split("/")[0];

    const dataBinder = new DataBinder();
    dataBinder.populate(pageId, model);

    const swapPage = new SwapPage();
    swapPage.swapPage(pageId);
  }
  avatarRandom() {
    const app = this.app;
    const items = app.items;
    if (items.getRandomAvatar) {
      let avatar = items.getRandomAvatar();
      return avatar;
    }
  }
  loginGuest() {
    const app = this.app;
    const userdata = app.userdata;
    const accountJD = app.accountJD;
    let name = "Player" + Math.floor(Math.random() * 1000000);
    let email = Math.floor(Math.random() * 1000000000000) + "@fake.com";
    let avatar = userdata.avatar;


    if (!userdata.name) userdata.name = name;
    if (!userdata.email) userdata.email = email; //set email to prevent needing to login everytime the app opens
    if (!userdata.avatar) userdata.avatar = this.avatarRandom();//get random avatar if none

    //Get Id in the the background if the user does not have one
    if (!userdata.id) {
      let regData = {
        name: name,
        email: email,
        password: "",
        avatar: avatar,
        emailSubscribe: false
      };
      accountJD.Register(regData)
        .then((data) => {
          if (!data || !data.id) return;
          if (data.id) userdata.id = data.id;
          if (data.name) userdata.name = data.name;
          if (data.email) userdata.email = data.email;
          if (data.facebookId) userdata.facebookId = data.facebookId;
          if (data.avatar) userdata.avatar = data.avatar;
          if (data.emailSubscribe) userdata.emailSubscribe = data.emailSubscribe;
          app.save();
        }).catch(
          (e) => { }
        ).finally(() => {
          app.navigate("MainMenu");
          app.dataLoaded();
          app.save();
        });
    } else {
      app.navigate("MainMenu");
      app.dataLoaded();
    }
  };

}